/*
 * Filename: d:\projects\AutoFiFront\src\Theme\CartIcon.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 11:52:47 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const CartIcon = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
padding-right: 0.1rem;
color: ${(props: any) => getThemeColor(props.bgColor)};
`;

export default CartIcon;
